interface Props {
    steps: number
    currentStep: number
}

export default function ProgressStepper({ steps, currentStep }: Props) {
    return (
        <div className={`grid grid-cols-${steps} w-full max-w-sm gap-3 `}>
            {Array.from({ length: steps }).map((_, index) => (
                <div
                    key={index}
                    className={`h-2 w-full flex-grow rounded ${
                        currentStep >= index + 1 ? 'bg-green-500' : 'bg-white'
                    } `}
                ></div>
            ))}
        </div>
    )
}
